import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { PopupData } from 'webapp-types';
import type { Theme } from 'webapp/enums/enums';
import { AttachPosition, TimeUnit } from 'webapp/enums/enums';

import FormGranulationPopupComponent from 'webapp/components/form/granulation/popup';
import FormSelectWithPopupAsDropdownComponent from 'webapp/components/form/select-with-popup-as-dropdown';

import DateRange from 'webapp/models-custom/date-range';
import type MetricLimitations from 'webapp/models-custom/metric-limitations';

interface Args {
	metricLimitations: MetricLimitations;
	onChange: (granulationId: string | null) => void;
	theme?: Theme | string;
	size?: string;
	placeholder?: string;
	isDisabled?: boolean;
	exceptionIds?: string[];
	trackingOrigin?: string;
	popupOffset?: number;
}

export default class FormGranulationDropdownComponent extends Component<Args> {
	get dateRange() {
		return this.args.metricLimitations.dateRange;
	}

	// ------ for select dropdown ----- //

	get selected() {
		return this.dateRange?.granulationTypeId;
	}

	get options() {
		return DateRange.predefinedGranulations
			.filter((item) => item.unit !== TimeUnit.TOTAL)
			.map((gran) => {
				return {
					value: gran.id,
					label: gran.title,
				};
			});
	}

	@action
	doNothing() {
		// changes on this dropdown will go through the popup
		// since the dropdown cannot even be opened
	}

	// ------ for popup ----- //

	popupComponent = FormGranulationPopupComponent;

	popupClass = 'popup-cdr';

	popupAttachPosition = AttachPosition.START;
	popupalignEdgeWithAttachTo = true;

	get exceptionIds() {
		// won't be showing these categories in the popup
		return this.args.exceptionIds || [];
	}

	@action
	getPopupProps() {
		const popupData: PopupData.Form.Granulation = {
			metricLimitations: this.args.metricLimitations,
			exceptionIds: this.exceptionIds,
			trackingOrigin: this.args.trackingOrigin,
			onChange: this.args.onChange,
		};
		return popupData;
	}
	<template>
		<FormSelectWithPopupAsDropdownComponent
			@selected={{this.selected}}
			@options={{this.options}}
			@onChange={{this.doNothing}}
			@isNumeric={{false}}
			@placeholder={{@placeholder}}
			@isDisabled={{@isDisabled}}
			@theme={{@theme}}
			@size={{@size}}
			@popupComponent={{this.popupComponent}}
			@popupClass={{this.popupClass}}
			@getPopupProps={{this.getPopupProps}}
			@popupOffset={{@popupOffset}}
			@popupAttachPosition={{this.popupAttachPosition}}
			@popupalignEdgeWithAttachTo={{this.popupalignEdgeWithAttachTo}}
		/>
	</template>
}
